import { memo, type ReactElement } from 'react';
import useT, { useTArgs } from '../hooks/useT';

const T = ({ _str, ...args }: { _str: string } & useTArgs): ReactElement => {
  const translation = useT(_str, args);

  return translation as unknown as ReactElement;
};

export default memo(T);
